import React, { useState, useEffect, useMemo } from 'react';
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import * as settingsAction from "store/entities/settingsInfo/action";
import * as dashboardActions from "store/entities/dashboard/action";
import * as accountActions from "store/auth/account/action";

import { ButtonLoader, Input } from "components/__new/common/form";
import { message } from 'data/toast';
import FormDrawer from '../form-drawer';
import validate from "utils/validate";
import { excludeProperties } from "utils/excludeProperties";
import { capitalizeFirstLetter } from "utils/stringFormatter";
import { REGEX_VALUES } from 'utils/regexValues';


const PersonalInfoModal = (props) => {
const dispatch = useDispatch();
const {isOpen, setIsOpen, isEdited, setIsEdited, dashboard} = props
// const {firstName, lastName, phoneNumber, email, jobTitle} = dashboard?.member
// const {PROFILE_UPDATED} = message

const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    phoneNumber: "",
    email: "",
    jobTitle: "",
    role: "",
    profileImage: null
})

const [formErrors, setFormErrors] = useState({
    firstName: null,
    lastName: null,
    phoneNumber: null,
    // email: null,
    jobTitle: null
});

const { updatePersonalInfoLoading, editTeamMember, editTeamMemberLoading } = useSelector((state) => state.entities.settingsInfo);


const handlePersonalInfoChange = (e) => {
    const { name, value } = e.target;
    if ((!REGEX_VALUES.LETTERS_WITH_UNDERSCORE_AND_HYPHEN_ONLY.test(value) || value.length > 30)) {
        return;
        // setFormErrors({
        //     ...formErrors,
        //     [name]: "Name must be at least two characters",
        // })
        // } else {
        //   setFormErrors({
        //     ...formErrors,
        //     [name]: null,
        // })
        }
        
    setForm(prevForm => ({
        ...prevForm,
        [name]: value
    }));
};

const handlePhoneChange = (e) => {
    const { name, value } = e.target;
    if ((name === "phoneNumber" ) && (REGEX_VALUES.PHONE_NUMBER.test(value) )) {
      setFormErrors({
        ...formErrors,
        phoneNumber: "Phone number must be 11 digits",
    })
    } else {
      setFormErrors({
        ...formErrors,
        phoneNumber: null,
    })
    }
    if ((value.length !== 12) && (value >= 0)) {
        setForm({...form, phoneNumber: value})
    } 
}

const handleJobTitleChange = (e) => {
    const { name, value } = e.target;
    if ((name === "jobTitle") && (!REGEX_VALUES.LETTERS_WITH_UNDERSCORE_AND_HYPHEN_ONLY_WITH_SPACE_.test(value) || value.length > 50)) {
        return;
    }
    
    setForm({...form, jobTitle: value})
  }

const submitForm = async (e) => {
    e.preventDefault();
    const updatedPayload = excludeProperties(form, 'email')
    const errors = validate(updatedPayload);
    if (errors){
        for (var x in errors) {
            toast.error(errors[x]);
        };
        return;
    }
    else{
        const params = {
            ...updatedPayload,
            email: dashboard?.member?.email,
            role: dashboard?.member?.roleId,
            profileImage: dashboard?.member?.profileImage,
        }
        dispatch(settingsAction.editTeamMember(params, dashboard?.member?.id));
        setIsEdited(true)
        // dispatch(settingsAction.updatePersonalInfo(params));
        // dispatch(accountActions.updateLoggedInPersistedStorage(updatedPayload));
        // dispatch(accountActions.resetUpdateProfile());

    }
}

const isButtonDisabled = useMemo(() => {

    if((form.firstName.length < 2 || form.lastName.length < 2 || form.phoneNumber.length !== 11 ) || form.jobTitle < 3){
      return true;
    } 
  }, [form])
  
  useEffect(() => {
    setForm({
        firstName: capitalizeFirstLetter(dashboard?.member?.firstName) || '',
        lastName: capitalizeFirstLetter(dashboard?.member?.lastName) || '',
        phoneNumber: dashboard?.member?.phoneNumber || '',
        email: dashboard?.member?.email || '',
        jobTitle: dashboard?.member?.jobTitle || '',
    });
  }, [dashboard]);
  
  

    return (
    
    <FormDrawer display="center" size="md" isOpen={isOpen} setIsOpen={setIsOpen}>
            <form className="p-6" onSubmit={submitForm}>
                <FormDrawer.Title
                    title="Edit Personal Info"
                    description="Manage your personal information"
                    showCloseButton={true}
                    close={setIsOpen}
                />
                
                <hr />
                
                <div className='py-4 text-ep-gray-700'>
                    <Input
                        type="text"
                        label="First Name"
                        placeholder=""
                        name="firstName"
                        tagText={formErrors?.firstName}
                        tagTextIsRed
                        value={form.firstName}
                        onChange={handlePersonalInfoChange}
                    />
                    <Input
                        type="text"
                        label="Last Name"
                        placeholder=""
                        name="lastName"
                        tagText={formErrors?.lastName}
                        tagTextIsRed
                        value={form.lastName}
                        onChange={handlePersonalInfoChange}
                    />
                    <Input
                        type="text"
                        label="Phone Number"
                        placeholder=""
                        name="phoneNumber"
                        tagText={formErrors?.phoneNumber}
                        tagTextIsRed
                        value={form.phoneNumber}
                        onChange={handlePhoneChange}
                    />
                    <Input
                        type="text"
                        label="Email Address"
                        placeholder=""
                        name="email"
                        value={form.email}
                        onChange={handlePersonalInfoChange}
                        readonly
                    />
                    <Input
                        type="text"
                        label="Job Title"
                        placeholder=""
                        name="jobTitle"
                        tagText={formErrors?.jobTitle}
                        tagTextIsRed
                        value={form.jobTitle}
                        onChange={handleJobTitleChange}
                    />
                </div>
                <div className="p-1 mt-4 flex justify-end space-x-3">
                    <button onClick={setIsOpen} type="button" className="btn btn-lg w-full rounded-lg whitespace-nowrap border border-ep-primary-600 text-ep-primary-600 bg-white"                    >
                        Cancel
                    </button>
                    <ButtonLoader type="submit" loading={editTeamMemberLoading} disabled={isButtonDisabled} className="btn btn-lg w-full rounded-lg whitespace-nowrap border border-ep-primary-600 text-white bg-ep-primary-600">
                        Save Changes
                    </ButtonLoader>
                </div>
            </form>
        </FormDrawer>
  )
}

export default PersonalInfoModal
